/** Main project script */



// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}
var statsViewed = false;

// main code
so.app = {

    init: function () {
        this.megaMenuTrigger();
        this.toggleNavigation();
        this.searchPopoverTrigger();
        this.megaMenuSearchTrigger();
        this.toggleSubNavigation();
        this.toggleSearch();
        this.megaMenuTiering();
        this.formPaginationHelper();
        if ($('#stats-panel').length) {
            window.onscroll = function() { so.app.statsScroll() };
        }
    },
    megaMenuTrigger() {
        $(".mega-menu-trigger").click(function(e) {
            e.preventDefault();

            so.app.closeSearchPopover();

            $(".nav-main").toggleClass('mega-menu-open');
            $(".mega-menu").toggleClass('open');
        });
    },
    megaMenuTiering() {
        $(".mega-menu-icon").click(function(e) {
            e.preventDefault();

            var targ = $(this).attr('data-menu-target');

            $(".mega-menu-item-link").removeClass("active in-section");

            $(this).parent().addClass('active in-section');
            $(this).parents(".mega-menu-col").nextAll('.mega-menu-col').find('.mega-menu-sub').removeClass('open');
            $(".mega-menu-sub[data-menu='" + targ + "']").addClass('open');
            $(".mega-menu-sub[data-menu='" + targ + "']").parents(".mega-menu-col").toggleClass('open').siblings().removeClass('open');
        });

        $(".mega-menu-back").click(function(e) {
            e.preventDefault();

            $(this).parents(".mega-menu-col").removeClass('open').prev().addClass('open');
        });
    },
    toggleNavigation() {
        $(".nav-main-trigger").click(function(e) {
            e.preventDefault();

            so.app.closeSearchPopover();

            $(".nav-main").toggleClass('nav-main-open');
        });
    },
    toggleSubNavigation() {
        $(".nav-main-sub-menu-trigger").click(function() {
            var target = $(this).attr('data-target');

            if ($(this).attr('aria-expanded') === 'true') {
                $(this).attr('aria-expanded', 'false');
            } else {
                $(this).attr('aria-expanded', 'true');
            }

            $(target).toggleClass('nav-main-sub-menu-open');
        });
    },
    closeMegaMenu() {
        $(".nav-main").removeClass('nav-main-open');
        $(".nav-main").removeClass('mega-menu-open');
        $(".mega-menu").removeClass('open');
    },
    closeSearchPopover() {
        $(".nav-main").removeClass('search-popover-open');
        $(".search-popover").removeClass('open');
    },
    megaMenuSearchTrigger() {
        $(".search-popover-trigger").click(function(e) {
            e.preventDefault();

            so.app.closeMegaMenu();

            $(".nav-main").toggleClass('search-popover-open');
        });
    },
    searchPopoverTrigger() {
        $(".search-popover-trigger").click(function(e) {
            e.preventDefault();

            so.app.closeMegaMenu();

            $(".nav-main").toggleClass('search-popover-open');
            $(".search-popover, .suggestive-search-popover").toggleClass('open');

            //$(".search-popover form").toggle();
        });
    },
    //stats-counter
    toggleSearch: function () {
        $(".searchform-trigger").on('click', function (e) {
            e.preventDefault();
            //so.app.closeSearchPopover();

            $(".search").toggleClass('search-open');
            //$(".searchform").toggleClass('d-flex');

            //so.app.heroNavColorChange();
        });
    },
    isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var elemTop = $(elem).offset().top;
        return (elemTop >= docViewTop);
    },

    statsScroll() {
        if (so.app.isScrolledIntoView($(".stat-item")) && !statsViewed) {
            statsViewed = true;
            $('.value').each(function () {
                $(this).prop('Counter',0).animate({
                    Counter: $(this).text()
                }, {
                    duration: 3000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now).toLocaleString('en'));
                    }
                });
            });
        }
    },

    formPaginationHelper() {
        $(".step-button-next, .step-button-prev").click(function(e) {
            //get the top of the form
            const formTop = $(this).closest("form").offset().top;
            const headerHeight = 122;
            //scroll to the top of the form
            if (formTop) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: formTop - headerHeight
                }, 500);
            }
        });
    }



};

$(document).ready(function () {
    so.app.init();
});
